import { Typography, useTheme, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getStatusColor, getStatusBackground } from '../helpers';

interface StatusCellProps {
  status: string;
  tPath?: string;
  sx?: SxProps<Theme>;
}

const StatusCell = ({ status, tPath, sx }: StatusCellProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Typography
      variant="body1"
      fontWeight="bold"
      sx={{
        color: getStatusColor(status, theme, 'pill'),
        backgroundColor: getStatusBackground(status, theme, 'pill'),
        paddingX: 1,
        paddingY: 0.18,
        borderRadius: '9999px',
        width: 'fit-content',
        fontSize: theme.custom.tableFontSizePx,
        justifySelf: 'center',
        ...sx,
      }}
    >
      {tPath ? t(tPath) : status}
    </Typography>
  );
};

export default StatusCell;
